(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kh-reviewbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.on === "1") return;
      root.dataset.on = "1";

      var slides = root.querySelectorAll(".kh-rev__slide");
      if (slides.length < 2) return;

      var i = 0;
      var timer = null;
      var wait = parseInt(root.getAttribute("data-speed"), 10) || 4200;

      function show(n) {
        for (var k = 0; k < slides.length; k++) {
          slides[k].classList.toggle("is-on", k === n);
        }
        i = n;
      }
      function start() {
        stop();
        timer = setInterval(function () { show((i + 1) % slides.length); }, wait);
      }
      function stop() { if (timer) clearInterval(timer); }

      show(0);
      if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) start();

      root.addEventListener("mouseenter", stop);
      root.addEventListener("mouseleave", start);
      root.addEventListener("focusin", stop);
      root.addEventListener("focusout", start);
      document.addEventListener("visibilitychange", function () {
        if (document.hidden) { stop(); } else { start(); }
      });
    }

    function boot() {
      document.querySelectorAll("[data-kh-rev]").forEach(init);
    }

    document.addEventListener("DOMContentLoaded", boot);
    document.addEventListener("shopify:section:load", boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
